import { Purchase } from '@/components/Buy/Purchase';
import { useAppState } from '@/hooks/useAppState';
import { AppHead } from '@/components/AppHead';
import { Breadcrumb } from '@/components/Breadcrumb';
import { useIntl } from 'react-intl';
import { Heading } from '@chakra-ui/react';
import { skuNameMessages } from '@/components/Buy/Sku';
import { SkuCode, skuEthPriceMap, skuMetaList } from '@lib/config';

export default function Buy() {
  const [state] = useAppState();
  const intl = useIntl();

  const pageTitle = intl.formatMessage({
    defaultMessage:
      '购买Discord自动聊天机器人 - 立即获取AI智能助手 | Discord SuperMan',
    id: 'buy.page.title',
  });

  const pageDescription = intl.formatMessage(
    {
      defaultMessage:
        '购买 Discord 自动聊天机器人授权，1 个月仅需 {price} ETH，另有 12 个月和永久买断方案，使用 ETH 支付，也可在 Arbitrum、Optimism、Base 等 L2 网络转账开通。包含 AI 自动聊天、自动回复、多账号和定时消息功能，订阅期内免费更新。',
      id: 'buy.page.description',
    },
    { price: String(skuEthPriceMap[SkuCode.m1]) },
  );

  const pageKeywords = intl.formatMessage({
    defaultMessage:
      '购买Discord机器人,Discord机器人价格,AI聊天机器人购买,Discord自动化工具,Discord SuperMan购买,以太坊支付,区块链支付',
    id: 'buy.page.keywords',
  });

  const productName = intl.formatMessage({
    defaultMessage: 'Discord 智能聊天助手',
    id: 'title',
  });

  // 购买页面专用的结构化数据
  const buyPageStructuredData = [
    // 产品详情
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: productName,
      description: pageDescription,
      category: 'SoftwareApplication',
      brand: {
        '@type': 'Brand',
        name: 'Discord SuperMan',
      },
      image: 'https://discordsuperman.xyz/assets/discord-superman-logo.png',
      offers: skuMetaList.map((sku) => ({
        '@type': 'Offer',
        name: intl.formatMessage(skuNameMessages[sku.skuCode]),
        price: String(sku.ethPrice),
        priceCurrency: 'ETH',
        availability: 'https://schema.org/InStock',
        url: 'https://discordsuperman.xyz/buy',
        seller: {
          '@type': 'Organization',
          name: 'Discord SuperMan',
        },
      })),
    },
    // 购买操作
    {
      '@context': 'https://schema.org',
      '@type': 'BuyAction',
      object: {
        '@type': 'Product',
        name: productName,
      },
      seller: {
        '@type': 'Organization',
        name: 'Discord SuperMan',
        url: 'https://discordsuperman.xyz',
      },
    },
  ];

  return (
    <>
      <AppHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        type="product"
        structuredData={buyPageStructuredData}
      />

      <Breadcrumb />
      <Heading as="h1" size="lg" mb={4} color="gray.800">
        {intl.formatMessage({
          defaultMessage: '购买 Discord 自动聊天机器人',
          id: 'buy.page.heading',
        })}
      </Heading>
      <Purchase referralCode={state.referralCode} />
    </>
  );
}
